/**
 * Navigation metadata, merged into the route table by `router/index.js`.
 *
 * Keyed by route name. Fields:
 * - `title`: page title (document.title and default back-button label of children)
 * - `parent`: route location "up" from this page (see `PageBack`); omitted → `home`
 * - `backLabel`: overrides the back-button label (default: parent's title, "Retour" for home)
 * - `staff`: route is reserved to staff users
 */
const adminTab = (tab) => ({ name: 'admin', query: { tab } })

export default {
  login: { title: 'Connexion' },
  cgv: { title: 'CGV' },
  politique_cookies: { title: 'Politique de cookies' },
  politique_confidentialite: { title: 'Politique de confidentialité' },
  mentions_legales: { title: 'Mentions légales' },
  about: { title: 'À propos' },
  home: { title: 'Accueil' },
  new: { title: 'Nouveau chantier' },
  chat_detail: { title: 'Conversation' },
  project_detail: { title: 'Chantier' },
  settings: { title: 'Réglages' },
  support: { title: 'Aide & Support' },
  tickets: { title: 'Tickets', parent: { name: 'support' } },
  ticket_new: { title: 'Nouveau ticket', parent: { name: 'tickets' } },
  ticket_detail: { title: 'Ticket', parent: { name: 'tickets' }, backLabel: 'Tickets' },
  faq: { title: 'FAQ', parent: { name: 'support' }, backLabel: "Centre d'aide" },
  faq_detail: { title: 'FAQ', parent: { name: 'faq' }, backLabel: 'FAQ' },
  help: { title: 'Aide' },
  sync: { title: 'Synchronisation' },
  manuel: { title: 'Manuel utilisateur' },
  service_unavailable: { title: 'Service indisponible' },
  not_found: { title: 'Page introuvable' },

  manuel_admin: { title: 'Manuel administrateur', staff: true, parent: { name: 'admin' } },
  admin: { title: 'Administration', staff: true },
  admin_tickets: { title: 'Tickets', staff: true, parent: { name: 'admin' } },
  admin_ticket_detail: {
    title: 'Ticket',
    staff: true,
    parent: { name: 'admin_tickets' },
    backLabel: 'Tickets',
  },
  admin_engine_edit: {
    title: 'Moteur',
    staff: true,
    parent: adminTab('moteurs'),
    backLabel: 'Moteurs',
  },
  admin_agent_session_detail: {
    title: 'Session Agent',
    staff: true,
    parent: adminTab('sessions'),
    backLabel: 'Sessions Agent',
  },
  admin_user_detail: {
    title: 'Utilisateur',
    staff: true,
    parent: adminTab('utilisateurs'),
    backLabel: 'Utilisateurs',
  },
  admin_organisation_detail: {
    title: 'Organisation',
    staff: true,
    parent: adminTab('organisations'),
    backLabel: 'Organisations',
  },
  // Parent is the team's organisation, known only once loaded: the view passes `to` to PageBack.
  admin_team_detail: {
    title: 'Équipe',
    staff: true,
    parent: adminTab('organisations'),
    backLabel: 'Organisations',
  },
  admin_stock_plan_detail: {
    title: 'Plan de stock',
    staff: true,
    parent: adminTab('plans-stock'),
    backLabel: 'Plans de stock',
  },
  admin_file_spreadsheet: {
    title: 'Fichier',
    staff: true,
    parent: adminTab('fichiers'),
    backLabel: 'Fichiers',
  },
  admin_conversations_browser: {
    title: 'Navigateur de conversations',
    staff: true,
    parent: { name: 'admin' },
    backLabel: 'Admin',
  },
  admin_comparative: {
    title: 'Évaluation comparative',
    staff: true,
    parent: { name: 'admin' },
  },
}
